import $ from 'jquery';
import config from 'lib/config';
import * as Utils from 'lib/utils';
import { uncrunch } from 'graphql-crunch';

const W = window;
const $D = $(document);
const history = [];

W.API = Utils.freeze($.unpack(W.API));

$(document).on('inserted.bs.popover', evt => {
  const data = $(evt.target).data('bs.popover');

  if (data && data.config.target === '#graphql-popover') {
    const $body = $(data.tip).find('.popover-body');

    $body.find('.recent').toggleClass('d-none', !history.length);

    if (history.length) {
      const $form = $body.find('form');
      const $list = $body.find('.list-group').empty();

      $list.off('click').on('click', '.list-group-item', evt => {
        const item = $(evt.target).data('item');

        $form.find('[name=payload]').val(JSON.stringify(item));
        $form.trigger('submit');
      });

      for (const item of history) {
        const $item = $('<a class="list-group-item list-group-item-action"></a>').data('item', item).text(item.operationName).appendTo($list);
      }
    }
  }
});

class GraphQL {
  constructor() {
    this.httpUri = config.api.uri + config.api.endpoint;
    this.headers = {
      'X-CLIENT-HOST': W.API.host,
      'X-CLIENT-TOKEN': W.API.client,
      'X-USER-TOKEN': W.API.user || undefined,
    };

    this.$proxy = $({});
  }

  on(type, fn) {
    this.$proxy.on(type, fn);
    return this;
  }

  async runQuery(query, opts) {
    const headers = { ...this.headers };
    const { crunch = true, session, ...options } = opts;

    if (session) headers['X-SESSION-TOKEN'] = session;
    if (crunch) headers['X-CRUNCH'] = crunch;
    if (opts && opts.operationName) headers['X-OPERATION-NAME'] = opts.operationName;

    const result = await new Promise((resolve, reject) => {
      const payload = { query, ...options };

      history.unshift(payload);
      if (history.length > 10) history.splice(10);

      $.ajax({
        url: this.httpUri,
        headers,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(payload),
        cache: false,
      })
        .done((data, status, xhr) => {
          const crunched = xhr.getResponseHeader('x-crunched') === 'true';

          if (crunched && data.data) data.data = uncrunch(data.data);
          if (crunched && data.extensions) data.extensions = uncrunch(data.extensions);

          data = Object.assign({}, { name: opts && opts.operationName }, data.data, data.extensions);

          resolve(data);
        })
        .fail((xhr, status, err) => {
          const crunched = xhr.getResponseHeader('x-crunched') === 'true';
          let data = xhr.responseJSON;

          if (xhr.readyState === 4 && data) {
            if (crunched && data.data) data.data = uncrunch(data.data);
            if (crunched && data.extensions) data.extensions = uncrunch(data.extensions);

            data = Object.assign({}, { name: opts && opts.operationName, data: null }, data.data, data.extensions);

            return resolve(data);
          }

          if (xhr.readyState === 0) err = new Error('Unable to connect to the server. Please try again.');

          //console.log(xhr, status, err);

          reject(err);
        });
    });

    return result;
  }
}

$.GraphQL = new GraphQL();
